import React from "react";
import Marquee from "react-fast-marquee";
import "./LCDDisplay.scss";

const LCDDisplay: React.FC<{
  title: string;
  date: string;
  venueCoverage: string;
  marquee: boolean;
}> = (props): JSX.Element => {
  return (
    <div className="LCDDisplay">
      <div className="lcd-content">
        <h1 className="ui header truncated">{props.title}</h1>
        <h1 className="ui header">{props.date}</h1>
        <div className="lcd-marquee-coverage">
          {props.marquee ? (
            <Marquee gradient={false} speed={20}>
              <h1 className="ui header">{props.venueCoverage}</h1>
            </Marquee>
          ) : (
            <h1 className="ui header truncated interact">
              {props.venueCoverage}
            </h1>
          )}
        </div>
        <div className="pixels" />
      </div>
    </div>
  );
};

export default LCDDisplay;
